/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.blockModule').directive('bulbBlockViewSwitcher', bulbBlockViewSwitcher);

function bulbBlockViewSwitcher() {
  return {
    restrict : 'E',
    scope : {
      infoType : '@'
    },
    templateUrl : 'ajs/components/block/blockviewswitcher.html',
    controller : 'BlockViewSwitcherController as blockViewSwitcherCtrl',
    bindToController : true,
    link : function(scope, element, attrs, blockViewSwitcherCtrl) {
      blockViewSwitcherCtrl.infoType = attrs.infoType;
    }
  };
}
